module.exports = __webpack_public_path__ + "img/icon-admin-delete.89f8c965.svg";